import { ISocketContextState } from "./SocketProvider.types";

export const defaultSocketContextState: ISocketContextState = {
  socket: null,
};
